import React, { useState } from 'react';
import { getPossibleClasses, addClassToTeacher, createClassTeacher, addRequest, duplicateClass } from '../../../../redux';
import { connect } from 'react-redux';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import './index.css';

function AddClassForms (props) {
    const [showDuplicateClassForm, setShowDuplicateClassForm] = useState(false);
    const [state, setState] = useState({
        class: "",
        name: "",
        status: "",
        addClicked: false,
        createClicked: false
    }, []);
    const getMappedClassOptions = () => {
        return props.classOptions && props.classOptions
                  .map((classObject, index) => {
                      return (
                          <MenuItem
                              key={index + classObject.name}
                              value={classObject.name}
                              primaryText={classObject.name}
                              id="class"
                          />
                      );
                  })
    }

    const handleChange = (e) => {
        setState({
            ...state,
            name: e.target.value
        });
    }

    const handleDropdownChange = (e) => {
        setState({
            ...state,
            class: e.target.innerText.trim()
        });
    }

    const handleStatusDropdownChange = (e) => {
        setState({
            ...state,
            status: e.target.innerText.trim()
        });
    }

    const handleAddClick = () => {
        setState({
            ...state,
            addClicked: !state.addClicked,
        })
    }

    const handleCreateClick = () => {
        setState({
            ...state,
            createClicked: !state.createClicked,
        });
    }

    const handleAddNewClass = () => {
        const newUserClasses = [...(props.user.classes || [])];
        const newClassId = props.possibleClasses.find(thisClass => thisClass.name === state.class)._id;
        newUserClasses.push(newClassId);
        if (state.class.trim() !== "") {
            const classObject = props.classOptions.find(thisClass => thisClass.name === state.class);
            props.addRequest({
                firstName: props.user.firstName,
                lastName: props.user.lastName,
                email: props.user.email,
                teacher: props.user._id,
                class: classObject._id,
                className: classObject.name
            }, props.requests);
            setState({
                ...state,
                addClicked: false,
                createClicked: false
            });
        }
    }

    const createClass = () => {
        if (state.name.trim() !== "" && state.status.trim() !== "") {
            props.createClassTeacher(
                props.user._id,
                {
                    name: state.name,
                    status: state.status
                },
                props.teacherClasses,
                props.possibleClasses
            );
            setState({
                ...state,
                addClicked: false,
                createClicked: false
            });
        }
    }

    const duplicateClass = () => {
        if (state.name.trim() !== "" && state.status.trim() !== "") {
            const c = props.possibleClasses.find(thisClass => thisClass.name === state.class);
            if(!c) {
                return
            }
            props.duplicateClass(
                c._id,
                {
                    name: state.name,
                    status: state.status
                },
            );
            setState({
                ...state,
                addClicked: false,
                createClicked: false
            });
            setShowDuplicateClassForm(false)
        }
    }

    function handleDuplicateClassClick() {
        setShowDuplicateClassForm(true)
        setState({
            ...state,
            class: "",
            name: "",
            status: "",
        })
    }

    if (state.addClicked) {
        return (
            <div className="addClassForms">
                <SelectField
                    hintText={"Select Class"}
                    name="class"
                    value={state.class}
                    onChange={handleDropdownChange}
                    fullWidth={true}
                >
                    {getMappedClassOptions()}
                </SelectField>
                <button onClick={handleAddClick} className="actionButton" style={{display: "block"}}>Close</button>
                <button onClick={handleAddNewClass} className="pink">Add</button>
            </div>
        )
    }

    if (state.createClicked) {
        return (
            <div className="addClassForms">
                <TextField
                    hintText="Class Name"
                    name="name"
                    value={state.name}
                    onChange={handleChange}
                    fullWidth={true}
                    style={{paddingLeft: "0"}}
                />

                <SelectField
                    hintText={"Class Status"}
                    name="status"
                    value={state.status}
                    onChange={handleStatusDropdownChange}
                    fullWidth={true}
                >
                    <MenuItem
                        key={"Active"}
                        value={"Active"}
                        primaryText={"Active"}
                        id="status"
                    />
                    <MenuItem
                        key={"Closed"}
                        value={"Closed"}
                        primaryText={"Closed"}
                        id="status"
                    />
                </SelectField>
                <button onClick={handleCreateClick} className="actionButton" style={{display: "block"}}>Close</button>
                <button onClick={createClass} className="pink">Create</button>
            </div>
        )
    }
    if (showDuplicateClassForm) {
      return (
        <div className="addClassForms">
          <SelectField
            hintText={"Select Class"}
            name="class"
            value={state.class}
            onChange={handleDropdownChange}
            fullWidth={true}
          >
            {props.possibleClasses &&
              props.possibleClasses.map((classObject, index) => {
                return (
                  <MenuItem
                    key={index + classObject.name}
                    value={classObject.name}
                    primaryText={classObject.name}
                    id="class"
                  />
                );
              })}
          </SelectField>
          <TextField
            hintText="Class Name"
            name="name"
            value={state.name}
            onChange={handleChange}
            fullWidth={true}
            style={{ paddingLeft: "0" }}
          />
          <SelectField
            hintText={"Class Status"}
            name="status"
            value={state.status}
            onChange={handleStatusDropdownChange}
            fullWidth={true}
          >
            <MenuItem
              key={"Active"}
              value={"Active"}
              primaryText={"Active"}
              id="status"
            />
            <MenuItem
              key={"Closed"}
              value={"Closed"}
              primaryText={"Closed"}
              id="status"
            />
          </SelectField>
          <button
            onClick={() => setShowDuplicateClassForm(false)}
            className="actionButton"
            style={{ display: "block" }}
          >
            Close
          </button>
          <button
            onClick={duplicateClass}
            className="actionButton"
            style={{ display: "block" }}
          >
            Duplicate
          </button>
        </div>
      );
    }

    return (
        <div>
            <button onClick={() => handleAddClick()} style={{marginRight: "20px", marginBottom: "20px"}} className="actionButton">
                Add Existing Class
            </button>
            <button onClick={() => handleCreateClick()} style={{marginRight: "20px", marginBottom: "20px"}} className="actionButton">
                Create New Class
            </button>
            <button onClick={handleDuplicateClassClick} className="actionButton">
                Duplicate class
            </button>
        </div>
    )
}

export default connect(state => state.root, { getPossibleClasses, addClassToTeacher, createClassTeacher, addRequest, duplicateClass })(AddClassForms);
